<template>
    <div class="panel-body">
        <div class="panel-nav">
            <button class="close-button" v-on:click.prevent="closePanel"></button>
        </div>
        <div class="scroller padded">
            <h2 class="panel-header"><img src="../assets/nav-news.png" />Aggiornamenti</h2>

            <loading-progress
                    :indeterminate="loading"
                    :hideBackground="true"
                    shape="line"
                    :size="420"
                    :width="420"
                    height="3"
            />

            <div class="placeholder-text" v-if="news.length==0">Non ci sono dati</div>

            <ul id="news-list" class="list">
                <li v-for="(_news, index) in news"
                    :class="'row-' + ((index % 2) ? 'odd' : 'even')"
                    v-on:click="goToStation(_news.iddistributore)">
                    <p :class="'status ' + _news.type.toLowerCase()">{{ _news.type }}</p>
                    <p class="description">{{ _news.title }}</p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

    import { serverBus } from '../main';
    import Api from "../api";

    export default {
        methods: {
            closePanel() {
                serverBus.$emit("closePanel");
            },
            goToStation(val) {
                serverBus.$emit("goToStation", val);
            },
            loadData(_position) {
                //FIXME: prendo i parametri dal parent
                this.fuel = this.$parent.$parent.$parent.$parent.fuel;

                if(_position) {
                    this.country = _position.country;
                } else {
                    this.country = this.$parent.$parent.$parent.$parent.country;
                }

                if(this.country && this.fuel) {
                    var $scope = this;

                    $scope.loading = true;

                    Api.getNews(this.fuel,this.country.idstato,function(err,res){
                        $scope.news = res;
                        $scope.loading = false;
                    });
                }
            }
        },
        data() {
            return {
                country: null,
                fuel: null,
                news: [],
                station_id: null,
                loading: false
            };
        },
        created() {
            serverBus.$on('areaChanged',this.loadData);
            serverBus.$emit('pageChanged',{page:'MapNews'});
            this.loadData(false);
        },
        watch: {
            station_id: function (val) {
                serverBus.$emit('stationIdChanged', val);
            }
        }
    }

</script>
